<template>
  <div class="main-content" id="panel">
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
              <div class="col-lg-8 col-6">
                <h2>Create Bid</h2>
              </div>
              <div class="col-lg-4 col-6 text-right bid">
                <button @click="cusipAddPopupOpen()" type="button" class="btn btn-success"> 
                  <i class="fas fa-plus-circle"></i> ADD CUSIP</button>
                <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                  <i @click="searchCusip()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                  <input v-on:keyup.enter="searchCusip" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search Cusip" aria-label="Search">
                  <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                </form>
              </div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <div class="card vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                      @click="sort('cusip')">CUSIP/COUPON</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturityDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturityDate'  ? 'sort-desc' : '']"  
                      @click="sort('maturityDate')">MATURITY DATE/<br>CALL DATE</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'state'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'state'  ? 'sort-desc' : '']"  
                      @click="sort('state')">STATE/<br>INSURER</th>
                     <th 
                      scope="col" 
                      class="text-center"
                      >Moody's/<br>S&P Rating</th>  

                    <th scope="col" class="text-center">BID PRICE</th>
                    <th scope="col" class="">PAR <br> VALUE</th>
                    <th scope="col" class="text-center">MINIMUM<br>QUANTITY</th>
                    <th scope="col" class="">MINIMUM QUANTITY <br> BID OPTION</th>
                    <th scope="col" class=""># OF DAYS</th>
                    <!-- <th scope="col" class="text-center">POINT TO</th>
                    <th scope="col" class="text-center">CURVE<br>YIELD</th>
                    <th scope="col" class=" text-center">YIELD<br>SPREAD </th>
                    <th scope="col">BPS RANGE <br> MIN/MAX </th>
                    <th scope="col" class="">FACTOR <br> RATIO</th> -->
                    <th scope="col" class=" text-center">ACTION</th>
                  </tr>
                </thead>
                <tbody class="list">
                    <tr v-if="totalRows == 0 && !loading">
                      <td>
                        <p class="nodata">No data available</p>
                      </td>
                    </tr>
                    <tr v-for="cusip in cusips" :key="cusip.id"  v-bind:class="{'active-row': cusip.isActive}">
                      <td >
                        <span @click="getCusipDetails(cusip)" class="cusips">{{cusip.cusip}}</span>
                        <span class="coupon">{{cusip.coupon  | percent(3) }}</span>
                        <!-- <span class="desc">{{cusip.description}}</span> -->
                      </td>
                      <td class="text-center">
                        <span class="maturity">{{cusip.maturityDate ? moment(cusip.maturityDate).format("MM/DD/YYYY") : "N/A"}}</span><br>
                        {{cusip.callDate ? moment(cusip.callDate).format("MM/DD/YYYY") : "N/A"}}
                      </td>
                      <td>
                        <span class="state">{{getStateName(cusip.stateId)}}</span>
                        <span class="insurer">{{cusip.bondInsurer ? cusip.bondInsurer : "N/A"}}</span>
                      </td>
                      <td class="text-center">
                        <span class="text-primary">{{cusip.ratingMoody ? cusip.ratingMoody : "N/A"}}</span>
                        <span class="insurer text-success">{{cusip.ratingSP ? cusip.ratingSP : "N/A"}}</span>
                      </td>
                      <td>
                        <div class="no-flex">
                          <!-- <select v-on:click.stop.prevent="" @change="bidTypeChange(cusip)" class="form-control" v-model="cusip.bidType">
                            <option value="">Please select</option>
                            <option value="YIELD">Yield</option>
                            <option value="BIDPRICE">Bid price</option>
                          </select> -->
                          <div class="yld-calc d-inline-flex mr-2">
                            <input v-on:keyup="callBps(cusip)" min="0.001" step="0.001" oninput="validity.valid||(value='');"  v-on:click.stop.prevent="" class="form-control form-control-sm" type="number" placeholder="0" v-model="cusip.amount">
                            <button :disabled="!cusip.amount" v-if="cusip.bidType == 'YIELD'"  @click="openYieldCal(cusip)" type="button" data-toggle="tooltip" data-placement="left" title="Yield Calculator" class="btn btn-primary btn-sm">Yld. Calc</button>
                            </div>
                          <div v-if="cusip.bidType == 'YIELD'" class="d-flex"><input  v-on:click.stop.prevent="" min="0.001" step="0.001" oninput="validity.valid||(value='');" class="form-control form-control-sm" type="number" placeholder="TMC Price" v-model="cusip.tmcPrice">
                            <span class="ml-1 mt-3 blueicon" data-toggle="tooltip" data-placement="left" title="Calculated Price">{{cusip.priceFromYieldCal}} <i class="fas fa-info-circle"></i></span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <input 
                          v-on:keyup="setMinQty($event,cusip)" 
                          v-on:click.stop.prevent=""  
                          class="form-control form-control-sm" 
                          type="text" 
                          placeholder="0" 
                          maxlength="10"
                          @keypress="isQuantity($event)"
                          v-model="cusip.quantity"></td>
                      <td>
                        <input 
                          class="form-control form-control-sm" 
                          v-on:click.stop.prevent=""  
                          type="text" 
                          placeholder="0"
                          maxlength="10"
                          @keypress="isQuantity($event)" 
                          v-model="cusip.minQty"></td>
                      <td>
                        <select v-on:click.stop.prevent="" class="form-control" v-model="cusip.bidKeepCancel">
                            <!-- <option value="">Please select</option> -->
                            <option value="CANCEL">Cancel the Bid</option>
                            <option value="KEEP">Keep the Bid</option>
                          </select>
                      </td>
                      <td>
                        <select v-on:click.stop.prevent="" class="form-control number" id="exampleFormControlSelect1"  v-model="cusip.noOfDays">
                            <option
                              v-for="validity in bidValidity"
                              :key="validity"
                            >{{validity}}</option>
                        </select>
                      </td>
                      <!-- <td><input v-on:click.stop.prevent="" class="form-control form-control-sm" type="number" placeholder="0" v-model="cusip.noOfDays"></td> -->

                      <!-- <td>
                        <div class="d-inline-flex no-flex">
                          <select 
                            :disabled="cusip.bidType == 'BIDPRICE' || moment(cusip.callDate).isSame(moment(cusip.maturityDate)) " 
                            @change="pointToSelected(cusip)" 
                            v-on:click.stop.prevent="" 
                            class="form-control" 
                            v-model="cusip.pointToDate">
                              <option value="">Please select</option>
                              <option value="CALL">Call</option>
                              <option value="MATURITY">Maturity</option>
                          </select>
                          <select 
                            v-on:click.stop.prevent=""  
                            :disabled="cusip.bidType == 'BIDPRICE' || moment(cusip.callDate).isSame(moment(cusip.maturityDate)) || !cusip.pointToDate "  
                            class="form-control" 
                            v-model="cusip.pointToCurve">
                              <option value="">Please select</option>
                              <option value="MUNICURVE">Muni Curve</option>
                              <option value="TENYEARTREASURRY">10 year Treasury</option>
                          </select>
                        </div>
                      </td>
                      <td class="text-center">
                        <span v-if="cusip.pointToCurve == 'MUNICURVE'">{{cusip.muniCurveYieldValue || 0}}</span>
                        <span v-if="cusip.pointToCurve == 'TENYEARTREASURRY'">{{cusip.tenYearYieldValue || 0}}</span>
                        <span v-if="cusip.pointToCurve == ''">0</span>
                      </td>
                      <td class="text-center">
                        <span v-if="cusip.pointToCurve == 'MUNICURVE'">{{cusip.municurveBpsValue || 0}}</span>
                        <span v-if="cusip.pointToCurve == 'TENYEARTREASURRY'">{{cusip.tenYearBpsValue || 0}}</span>
                        <span v-if="cusip.pointToCurve == ''">BPS 0</span>
                      </td>
                      <td class="text-center customSel">
                        <div class="input-group d-inline-flex">
                          <div class="d-inline-flex">
                            <input v-on:click.stop.prevent="" maxlength="10" :disabled="cusip.bidType == 'BIDPRICE'" type="text" class="form-control" @keypress="isQuantity($event)"  v-model="cusip.bpsRangeMin"  placeholder="min">
                          </div>
                          <div class="d-inline-flex">
                            <input v-on:click.stop.prevent="" maxlength="10" :disabled="cusip.bidType == 'BIDPRICE'" type="text" class="form-control" @keypress="isQuantity($event)"  v-model="cusip.bpsRangeMax"  placeholder="max">
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-inline-flex">
                          1 : <input min="0.001" step="0.001" oninput="validity.valid||(value='');"  :disabled="cusip.bidType == 'BIDPRICE'" v-on:click.stop.prevent=""  class="form-control form-control-sm" type="number" placeholder="0" v-model="cusip.factorRatio">
                        </div>
                      </td> -->
                      <td class="text-center" v-on:click.stop.prevent="">
                        <div class="d-inline-flex">
                          <a  @click="cusipEditPopupOpen(cusip)" class="editbtn"><i class="fas fa-pen-square green"></i></a>
                          <a ><button @click="selectedCusip = cusip ;getTraderSetting('bid')" type="button" class="btn btn-primary btn-sm"><i class="fas fa-gavel"></i> BID</button></a>  
                        </div>
                      </td>
                    </tr>

                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getCusipList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 offset-3 ">
           <bond-description 
              v-if="bondDescriptionData" 
              v-bind:muniCurveYieldOnCall="muniCurveYieldOnCall"  
              v-bind:muniCurveYieldOnMaturity="muniCurveYieldOnMaturity"  
              v-bind:tenYearYieldOnCall="tenYearYieldOnCall"  
              v-bind:tenYearYieldOnMaturity="tenYearYieldOnMaturity"  
              v-bind:bondDescriptionData="bondDescriptionData"
              v-bind:yieldLoader="yieldLoader"              
              v-bind:maturityErrorMessage="maturityErrorMessage"              
              v-bind:callErrorMessage="callErrorMessage"              
              @close="bondDescriptionData = null"/>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer/> -->
      <!-- Modal Create Bid -->
      <div
        class="modal fade"
        id="bidModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h3>{{appMessages.bidConfirm}}</h3>
              <!--<h4>BID SUMMARY</h4>-->
              <h4>{{selectedCusip.description}}</h4>
              <div class="row bidmodal">
                <div class="col bl" v-if="selectedCusip.bidType == 'YIELD'">Yield: {{selectedCusip.amount}} %</div>
                <div class="col bl" v-if="selectedCusip.bidType == 'YIELD'">TMC Price: {{selectedCusip.tmcPrice}}</div>
                <div class="col bl" v-if="selectedCusip.bidType == 'BIDPRICE'">Bid Price: {{selectedCusip.amount}}</div>
                <div class="col rd" >Par Value: {{selectedCusip.quantity}}</div>
                <div class="col rd" >Minimum Quantity: {{selectedCusip.minQty}}</div>
                <div class="col bl"># Of Days : {{selectedCusip.noOfDays}}</div>
                <div class="col bl" v-if="selectedCusip.bidType == 'YIELD'">Point To Date : {{selectedCusip.pointToDate}}</div>
                <div class="col bl" v-if="selectedCusip.bidType == 'YIELD'">Point To Curve : {{selectedCusip.pointToCurve =='MUNICURVE' ? 'Muni Curve' : '10 year Treasury'}}</div>

              </div>
               <div class="row bidmodal">                
                <div class="col bl" v-if="selectedCusip.bidType == 'YIELD' && selectedCusip.pointToCurve =='MUNICURVE'">Yield Spread  : {{selectedCusip.muniCurveYieldValue}}</div>
                <div class="col bl" v-if="selectedCusip.bidType == 'YIELD' && selectedCusip.pointToCurve =='TENYEARTREASURRY'">Yield Spread  : {{selectedCusip.tenYearYieldValue}}</div>
                <div class="col rd" v-if="selectedCusip.bidType == 'YIELD' && selectedCusip.pointToCurve =='MUNICURVE'">Curve Yield : {{selectedCusip.municurveBpsValue}}</div>
                <div class="col rd" v-if="selectedCusip.bidType == 'YIELD' && selectedCusip.pointToCurve =='TENYEARTREASURRY'">Curve Yield : {{selectedCusip.tenYearBpsValue}}</div>
                <div class="col rd" v-if="selectedCusip.bidType == 'YIELD'">Factor Ratio : 1 : {{selectedCusip.factorRatio || 0}}</div>
                <div class="col rd" v-if="selectedCusip.bidType == 'YIELD'">BPS Range Min : {{(selectedCusip.bpsRangeMin) || 0}}</div>
                <div class="col rd" v-if="selectedCusip.bidType == 'YIELD'">BPS Range Max : {{(selectedCusip.bpsRangeMax) || 0}}</div>
                <div class="col rd">Min Qty Bid Option : {{selectedCusip.bidKeepCancel == 'CANCEL' ? 'Cancel The Bid' : 'Keep The Bid' }}</div>

              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">CANCEL</button>
              <button type="submit" class="btn btn-primary my-2" @click="bid(selectedCusip)" >BID
              </button>
            </div>
            <div v-if="bidLoading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
          </div>
        </div>
      </div>
      <!-- Out standing Bid Popup -->
      <div
        class="modal fade"
        id="outstandingBid"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h3>There is an outstanding bid for the same cusip</h3>
              <p>Would you like to cancel the Outstanding Bid and place a new Bid?</p>
              <h4 class="cusip">{{selectedCusip.cusip}}</h4>
              <p>{{selectedCusip.description}}</p>
              <div class="bid-dtl">
                <div class="outstanding">
                  <div class="header">
                    <h4>Outstanding Bid</h4>
                    <h5 class="cursor-pointer" @click="openModal(outStandingBid.cognitoSub);"><i class="fas fa-user-circle"></i> {{outStandingBid.traderName}}</h5>
                  </div>
                  <div class="body">
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'" >Yield : <span>{{outStandingBid.amount}} %</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'" >TMC Price : <span>{{outStandingBid.tmcPrice}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'BIDPRICE'" >Bid Price : <span>{{outStandingBid.amount}}</span></div>
                    <div class="value">Par Value : <span>{{outStandingBid.quantity}}</span></div>
                    <div class="value">Minimum Quantity : <span>{{outStandingBid.minQuantity}}</span></div>
                    <div class="value"># Of Days : <span>{{outStandingBid.bidValidity}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">Factor Ratio : 1 : <span>{{outStandingBid.factorRatio || 0}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">Point To Date : <span>{{outStandingBid.pointToDate}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">Point To Curve  : <span>{{outStandingBid.pointToCurve =='MUNICURVE' ? 'Muni Curve' : '10 year Treasury'}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">Curve Yield : <span>{{outStandingBid.yield}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">Yield Spread : <span>{{outStandingBid.yieldSpread}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">BPS Range Min : <span>{{outStandingBid.minBps || 0}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">BPS Range Max : <span>{{outStandingBid.maxBps || 0}}</span></div>
                  </div>
                </div>
                <div class="newbid">
                  <div class="header">
                    <h4>New Bid</h4>
                  </div>
                  <div class="body">
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'" >Yield : <span>{{selectedCusip.amount}} %</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'BIDPRICE'" >Bid Price : <span>{{selectedCusip.amount}}</span></div>
                    <div class="value">Par Value : <span>{{selectedCusip.quantity}}</span></div>
                    <div class="value" >Minimum Quantity: {{selectedCusip.minQty}}</div>
                    <div class="value"># Of Days : <span>{{selectedCusip.noOfDays}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">Factor Ratio : 1 : <span>{{selectedCusip.factorRatio || 0}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">Point To Date : <span>{{selectedCusip.pointToDate}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">Point To Curve  : <span>{{selectedCusip.pointToCurve =='MUNICURVE' ? 'Muni Curve' : '10 year Treasury'}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD' && selectedCusip.pointToCurve =='MUNICURVE'">Yield Spread  : {{selectedCusip.muniCurveYieldValue}}</div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD' && selectedCusip.pointToCurve =='TENYEARTREASURRY'">Yield Spread  : {{selectedCusip.tenYearYieldValue}}</div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD' && selectedCusip.pointToCurve =='MUNICURVE'">Curve Yield : {{selectedCusip.municurveBpsValue}}</div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD' && selectedCusip.pointToCurve =='TENYEARTREASURRY'">Curve Yield : {{selectedCusip.tenYearBpsValue}}</div>
                    <!-- <div class="value" v-if="selectedCusip.bidType == 'YIELD'">Curve Yield : <span>{{selectedCusip.yield}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">Yield Spread : <span>{{selectedCusip.yieldSpread}}</span></div> -->
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">BPS Range Min : {{(selectedCusip.bpsRangeMin) || 0}}</div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">BPS Range Max : {{(selectedCusip.bpsRangeMax) || 0}}</div>
                    <div class="value">Min Qty Bid Option : {{selectedCusip.bidKeepCancel == 'CANCEL' ? 'Cancel The Bid' : 'Keep The Bid' }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="bidLoading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

            <div class="modal-footer bid-dtl-ftr">
              <router-link to="/bidside/bidlist"  data-dismiss="modal" >Goto Outstanding Bids </router-link>
              <button type="button" @click="cancelBidAndPlaceNewBid()" class="btn btn-danger">Cancel Outstanding Bid & Place New Bid</button>
            </div>
          </div>
        </div>
      </div>
      <trader-info 
        v-bind:traderInfo="traderData" 
        v-if="modalOpen" 
        @close="modalOpen = false"
      ></trader-info>
      <add-cusip 
        v-bind:addCusipObj="addCusipObj" 
        v-if="cusipModalOpen" 
        @close="closeAddCusipModal()"
      ></add-cusip>
      <yieldcalc 
        v-bind:offerPrice="bidPriceForYieldCal" 
        v-bind:offerYield="bidYieldForYieldCal" 
        v-bind:cusipid="yieldCusipId" 
        v-bind:settlementDate="this.bidSettings.settlementDate" 
        v-if="yieldModalOpen" 
        @close="yieldModalOpen = false"
        @yieldupdate="setCalculatedYield"
        @priceupdate="setCalculatedPrice"/>

    </div>
  </div>
</template>
<script>
import BondDescription from "../bondDescription";
import stateConstants from "@/stateConstants";
import TraderInfo from "../../admin/TraderInfoPopup"
import authService from "@/authService";
import config from "@/config";
import AddCusip from "./AddCusip";
import yieldcalc from "@/components/ims/ims-offering/ImsYieldCalculator";

export default {
  name: "bid",
  components: {
    BondDescription,
    TraderInfo,
    AddCusip,
    yieldcalc
  },
  data() {
    return {
      accessToken: null,
      cusips: [],
      config: config,
      loading : false,
      bidLoading : false,
      cusipLoading : false,
      currentPage: 1,
      perPage: 10,
      searchValue : "",
      totalRows : 0,
      selectedCusip : {},
      userSubId : "",
      sortColumn: "cusip",
      sortOrder: "ASC",
      bidSettings : {},
      addCusipObj : {
        cusip: "",
        maturityDate: "",
        description: "",
        bondInsurer: "",
        stateId: "",
        coupon: "",
        callDate: "",
        ratingSP: "",
        ratingMoody: ""
      },
      errors: {},
      stateConstants: stateConstants,
      bondDescriptionData : null,
      bidValidity : 3,
      outStandingBid : {},
      modalOpen: false,
      traderData:{},
      muniCurveYieldOnCall: 0,
      muniCurveYieldOnMaturity: 0,
      tenYearYieldOnCall :0,
      tenYearYieldOnMaturity :0,
      yieldLoader : false,
      cusipModalOpen : false,
      maturityErrorMessage : null,
      callErrorMessage : null,
      orgSettings : {},
      yieldModalOpen : false,
      yieldCusipId : null,
      bidPriceForYieldCal : null,
      bidYieldForYieldCal : null
    };
  },
  methods: {
    bidTypeChange(cusip){
      cusip.amount = 0;
      cusip.priceFromYieldCal = 0;
      cusip.tmcPrice = 0;
    },
    openYieldCal(cusip){
      this.yieldModalOpen = true;
      this.yieldCusipId = cusip.id;
      this.bidPriceForYieldCal = 0;
      this.bidYieldForYieldCal = cusip.amount;
    },
    setCalculatedYield(){

    },
    setCalculatedPrice(){

    },
    closeAddCusipModal(){
      this.cusipModalOpen = false;
      this.getCusipList();
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setMinQty(e,cusip){
     cusip.minQty = e.target.value;
    },
    callBps(cusip){
      setTimeout(()=> {
        this.getMuniCurveData(cusip);
        this.getTreasuryData(cusip);
        if(cusip.bidType == 'YIELD'){
          this.getPriceForYield(cusip);
        }
      },500)
    },
    getPriceForYield(cusip){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/cusip/yield-price-calculator?"+
            "cusipId="+cusip.id+
            "&yield="+cusip.amount+
            "&type=BID",
            auth
        )
        .then(result => {
          console.log(result);
          cusip.tmcPrice = result.data;
          cusip.priceFromYieldCal = result.data;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    openModal(cognitoSub) {
      this.bidLoading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user?cognitoSub="+
            cognitoSub,
            auth
        )
        .then(result => {
          this.modalOpen = true;
          this.traderData = result.data;
          this.bidLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.bidLoading = false;

        });
    }, 
    pointToSelected(cusip){
      if(cusip.pointToDate == ''){
        cusip.pointToCurve = "";
        return false;
      }
      if(cusip.pointToDate == 'CALL' && !cusip.callDate){
        this.$alert(this.appMessages.cusipNoCallDate,"","warning");
        cusip.pointToDate = "";
        cusip.pointToCurve = "";
        return false;
      }
      if(cusip.pointToDate == 'CALL' && !cusip.maturityDate){
        this.$alert(this.appMessages.cusipNoMaturityDate,"","warning");
        cusip.pointToDate = "";
        cusip.pointToCurve = "";
        return false;
      }
      if(cusip.pointToDate == 'CALL' && (this.moment(cusip.callDate).year() == this.moment().year())){
        this.$alert(this.appMessages.cusipCallDateEqualCurrentYear,"","warning");
        cusip.pointToDate = "";
        cusip.pointToCurve = "";
        return false;
      } 
      if(cusip.pointToDate == 'MATURITY' && (this.moment(cusip.maturityDate).year() == this.moment().year())){
        this.$alert(this.appMessages.cusipMaturityDateEqualCurrentYear,"","warning");
        cusip.pointToDate = "";
        cusip.pointToCurve = "";
        return false;
      } 
      this.getMuniCurveData(cusip);
      this.getTreasuryData(cusip);
    },
    searchCusip(){
      this.getCusipList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getCusipList(); 
    },
    cusipAddPopupOpen(){
      this.cusipValidationErrors = [];
      this.addCusipObj = {
                            cusip: "",
                            maturityDate: "",
                            description: "",
                            bondInsurer: "",
                            stateId: "",
                            callDate: "",
                            ratingSP : "",
                            ratingMoody : "",
                            coupon : "",
                            offeringTypeId : ""
                            }
      //window.$("#addcusip").modal("show");
      this.cusipModalOpen = true;
    },
    cusipEditPopupOpen(cusip){
      //console.log(this.toPercentage(editCusip.coupon);)
      // this.cusipEditMode = true;
      var editCusip = {...cusip};
      this.cusipValidationErrors = [];
      editCusip.ratingSP = editCusip.ratingSP ? editCusip.ratingSP.trim(): "";
      editCusip.ratingMoody = editCusip.ratingMoody ? editCusip.ratingMoody.trim() : "";
      editCusip.coupon =  this.toPercentage(editCusip.coupon,3);
      this.addCusipObj = editCusip;
      //window.$("#addcusip").modal("show");
      this.cusipModalOpen = true;
    },
    toPercentage(value, decimals){
       if (!value) {
        value = 0
      }
      if (!decimals) {
        decimals = 0
      }
      value = value * 100
      value = value.toFixed(decimals)
      return value
    },
    checkBidValid(){
      console.log(this.selectedCusip);

      if(!this.orgSettings.tmcAccountId){
        this.$alert(this.appMessages.tmcAccountNotSetError,"","warning");
        return false
      }
      if(this.bidSettings.allowedCusips  == 0 ){
        this.$alert(this.appMessages.maxNumberCusipLimit,"","warning");
        return false
      }
      if(this.selectedCusip.bidType == ""){
        this.$alert(this.appMessages.yiledOrBidpriceMissing,"","warning");
        return false 
      }
      if(this.selectedCusip.bidType == 'YIELD' && (this.selectedCusip.amount == "" || parseFloat(this.selectedCusip.amount) == 0)){
        this.$alert(this.appMessages.yiledValueMissing,"","warning");
        return false
      }
      if(this.selectedCusip.bidType == 'YIELD' && parseFloat(this.selectedCusip.amount) > 10){
        this.$alert(this.appMessages.yieldValueGreatethanTen,"","warning");
        return false
      }
      if(this.selectedCusip.bidType == 'YIELD' && (this.selectedCusip.tmcPrice == "" || parseFloat(this.selectedCusip.tmcPrice) == 0)){
        this.$alert(this.appMessages.tmcPriceMissing,"","warning");
        return false
      }
      if(this.selectedCusip.bidType == 'BIDPRICE' && (this.selectedCusip.amount == "" || parseFloat(this.selectedCusip.amount) == 0)){
        this.$alert(this.appMessages.bidPriceMissing,"","warning");
        return false
      }
      if(this.selectedCusip.bidType == 'BIDPRICE' && parseFloat(this.selectedCusip.amount) > 160){
        this.$alert(this.appMessages.bidPriceGreatethan160,"","warning");
        return false
      }
      if(this.selectedCusip.quantity == "" || parseFloat(this.selectedCusip.quantity) == 0){
        this.$alert(this.appMessages.parValueMissing,"","warning");
        return false
      }
      if(this.selectedCusip.minQty == "" || parseFloat(this.selectedCusip.minQty) == 0){
        this.$alert(this.appMessages.minQtyMissing,"","warning");
        return false
      }
      //Restrict quantities  multiples of 5 for MUNI cusips
      if(this.selectedCusip.offeringTypeId === 1 && (parseFloat(this.selectedCusip.quantity) % 5 || parseFloat(this.selectedCusip.minQty) % 5 )){
        this.$alert(this.appMessages.parValueMinQtyMultipleFiveError,"","warning");
        return false
      }
      // if(this.selectedCusip.bidType == 'BIDPRICE' && (this.selectedCusip.quantity * this.selectedCusip.amount) == 0 ){
      //   this.$alert("Bid total cost is zero","","warning");
      //   return false
      // }
      if(this.bidSettings.maxParValue < this.selectedCusip.quantity ){
        var message = "The Par value that you have entered must be less than or equal to "+this.bidSettings.maxParValue+" which is set by the Administrator."
        this.$alert(message,"","warning");
        return false
      }
      var formattedPrice = '$' + new Intl.NumberFormat('en-US', { }).format(this.bidSettings.allowedBalCapital);
      if(this.selectedCusip.bidType == 'BIDPRICE' && (this.bidSettings.allowedBalCapital - (this.selectedCusip.quantity * (this.selectedCusip.amount * 10)) < 0)  ){
        this.$alert("You don’t have sufficient capital amount balance to complete this bid.Your available balance is "+formattedPrice+".Please contact your administrator.","","warning");
        return false
      }
      if(this.selectedCusip.bidType == 'YIELD' && (this.bidSettings.allowedBalCapital - (this.selectedCusip.quantity * (this.selectedCusip.tmcPrice * 10)) < 0)  ){
        this.$alert("You don’t have sufficient TMC capital amount balance to complete this bid.Your available balance is "+formattedPrice+".Please contact your administrator.","","warning");
        return false
      }
      var formattedPriceTMC = '$' + new Intl.NumberFormat('en-US', { }).format(this.bidSettings.allowedTmcBalCapital);
      if(this.selectedCusip.bidType == 'YIELD' && (this.bidSettings.allowedTmcBalCapital - (this.selectedCusip.quantity * (this.selectedCusip.priceFromYieldCal * 10)) < 0)  ){
        this.$alert("You don’t have sufficient TMC capital amount balance to complete this bid.Your available balance is "+formattedPriceTMC+".Please contact your administrator.","","warning");
        return false
      }
      if(this.bidSettings.bidValidity < this.selectedCusip.validity ){
        this.$alert("Bid validity has to be less than or equal to "+this.bidSettings.bidValidity,"","warning");
        return false
      }
      if(this.selectedCusip.bidType == 'YIELD' && (parseFloat(this.selectedCusip.minQty) > parseFloat(this.selectedCusip.quantity))){
        this.$alert(this.appMessages.minQtyLessThanParValue,"","warning");
        return false
      }
      var yiledValue;
      if(this.selectedCusip.pointToCurve == 'MUNICURVE'){
        yiledValue =  this.selectedCusip.muniCurveYieldValue
      }
      if(this.selectedCusip.pointToCurve == 'TENYEARTREASURRY'){
        yiledValue =  this.selectedCusip.tenYearYieldValue
      }
      if(this.selectedCusip.bidType == 'YIELD' && yiledValue <= 0){
        this.$alert(this.appMessages.curveYiledNotValid,"","warning");
        return false
      }
      var minVal =  this.selectedCusip.bpsRangeMin
      var maxVal =  this.selectedCusip.bpsRangeMax
      if(this.selectedCusip.bidType == 'YIELD' && (parseFloat(minVal) > parseFloat(maxVal))){
        this.$alert(this.appMessages.BpsMinGreaterThanMax,"","warning");
        return false
      }
      if(this.selectedCusip.bidType == 'YIELD' && (this.selectedCusip.pointToDate && this.selectedCusip.pointToCurve == "" )){
        this.$alert(this.appMessages.pointToCurveIsrequired,"","warning");
        return false
      }
      if(this.selectedCusip.bidType == 'YIELD' && (this.selectedCusip.pointToCurve && this.selectedCusip.pointToDate == "" )){
        this.$alert(this.appMessages.pointToDateIsrequired,"","warning");
        return false
      }
       if(this.selectedCusip.bidType == 'YIELD' && (this.selectedCusip.pointToCurve && this.selectedCusip.pointToDate) &&  this.selectedCusip.factorRatio == ""){
        this.$alert(this.appMessages.bidFactorRationIsrequired,"","warning");
        return false
      }
      
      this.checkOutstandingBid(this.selectedCusip.id);
    },
    checkOutstandingBid(cusipId){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
          "/bid/outstanding/list?cusipId="+
            cusipId,
          auth
        )
        .then(response => {
          this.outStandingBid = response.data;
          this.loading = false;
          if(this.outStandingBid.id){
             window.$('#outstandingBid').modal("show");
          }else{
            window.$('#bidModal').modal("show");
          }    
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    cancelBidAndPlaceNewBid(){
      
      this.bid(this.selectedCusip);

      // this.bidLoading = true;
      // const auth = {
      //   headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      // };
      // this.$http
      //   .post(
      //     config.baseUrlBidSide + "/bid/cancel",
      //     {
      //       bidIds: [this.outStandingBid.id]
      //     },
      //     auth
      //   )
      //   .then(() => {
      //     this.bid(this.selectedCusip);
      //   })
      //   .catch(e => {
      //     this.bidLoading = false;
      //     console.log(e);
      //   });

    },
    getTraderSetting(rule){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
          "/user?cognitoSub="+
            this.userSubId,
          auth
        )
        .then(response => {
          this.bidSettings = response.data;
          this.bidValidity = this.bidSettings.bidValidity || 3;
          this.loading = false;

          if(rule == 'onLoad'){
            this.getCusipList();
          }
          if(rule == 'bid'){
            this.checkBidValid();
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getCusipList();
    },
    bid(selectedCusip){

      this.bidLoading  = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };

      var dataTosend = {};

      if(selectedCusip.bidType == "BIDPRICE"){
          dataTosend =  {
            cusipId : selectedCusip.id,
            traderCognitoSub : this.userSubId,
            quantity : Number(selectedCusip.quantity),
            amount : Number(selectedCusip.amount),
            bidValidity : Number(selectedCusip.noOfDays),
            bidType   : selectedCusip.bidType,
            minQuantity   : selectedCusip.minQty,
            pointToDate : null,
            pointToCurve : null,
            factorRatio  : null,
            curveYield : null,
            yieldSpread : null,
            minBps : null,
            maxBps : null,
            tmcPrice : null,
            bidKeepCancel : selectedCusip.bidKeepCancel

          }
      }

      if(selectedCusip.bidType == "YIELD"){

         var yieldVal = null;
         var yieldSpreadVal = null;
         if(selectedCusip.pointToCurve == 'MUNICURVE'){
           yieldVal = selectedCusip.muniCurveYieldValue || null;
           yieldSpreadVal = selectedCusip.municurveBpsValue || null;
         }
         if(selectedCusip.pointToCurve == 'TENYEARTREASURRY'){
           yieldVal = selectedCusip.tenYearYieldValue || null;
           yieldSpreadVal = selectedCusip.tenYearBpsValue || null;
         }
         dataTosend = {
            cusipId : selectedCusip.id,
            traderCognitoSub : this.userSubId,
            quantity : Number(selectedCusip.quantity),
            amount : Number(selectedCusip.amount),
            tmcPrice : Number(selectedCusip.tmcPrice),
            bidValidity : Number(selectedCusip.noOfDays),
            bidType   : selectedCusip.bidType,
            minQuantity   : selectedCusip.minQty,
            pointToDate : selectedCusip.pointToDate == "" ? null : selectedCusip.pointToDate,
            pointToCurve : selectedCusip.pointToCurve == "" ? null : selectedCusip.pointToCurve,
            factorRatio  : selectedCusip.factorRatio == "" ? null : selectedCusip.factorRatio,
            minBps : selectedCusip.bpsRangeMin == "" ? null :  selectedCusip.bpsRangeMin,
            maxBps : selectedCusip.bpsRangeMax == "" ? null :  selectedCusip.bpsRangeMax,
            curveYield : yieldVal,
            yieldSpread : yieldSpreadVal,
            bidKeepCancel : selectedCusip.bidKeepCancel,
            calculatedAmount : selectedCusip.priceFromYieldCal || 0
          }
      }

      this.$http
        .post(
          config.baseUrlBidSide + "/bid",
          dataTosend,
          auth
        )
        .then(response => {
          console.log(response);
          this.$alert(this.appMessages.bidSuccess,"","success");
          this.bidLoading = false;
          window.$('#bidModal').modal("hide");
          window.$('#outstandingBid').modal("hide");
          this.getCusipList();
        })
        .catch(e => {
          console.log(e);
          this.bidLoading = false;
          window.$('#bidModal').modal("hide");
          window.$('#outstandingBid').modal("hide");

        });
    },

    getCusipList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/cusip/list?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&cusip=" +
            this.searchValue +
            "&status=ACTIVE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
             "&type=BID",
            auth

        )
        .then(result => {
          console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
          var self = this;
          result.data.content.forEach(function(cusip) {
           cusip.quantity = "";
           cusip.amount = "";
           cusip.tmcPrice = "";
           cusip.bidType = "BIDPRICE";
           cusip.pointToDate = "";
           cusip.pointToCurve = "";
           cusip.yield = 0;
           cusip.muniCurveYieldValue = 0;
           cusip.tenYearYieldValue = 0;
           cusip.municurveBpsValue = "BPS 0";
           cusip.tenYearBpsValue = "BPS 0";
           cusip.factorRatio = "";
           cusip.minQty = "";
           cusip.bpsRangeMin = "";
           cusip.bpsRangeMax = "";
           cusip.bidKeepCancel = "CANCEL";
           cusip.noOfDays = self.bidSettings.bidValidity || 3;
           cusip.isActive = false;
           cusip.priceFromYieldCal = 0;
          });
           this.cusips = result.data.content;
           this.loading = false;
        })
        .catch(() => {
          //console.log("Error", e);
          self.loading = false;
        });
    },
    getCusipDetails(cusipSelected){
      this.cusips.forEach(function(cusip) {
        cusip.isActive = false;
      });
      cusipSelected.isActive = true;
      // var maturityDate = cusipSelected.maturityDate.replace(/-/g, "");
      this.bondDescriptionData = cusipSelected;
      //this.getCurveDetails(cusipSelected);
      // if(!this.bondDescriptionData.muniCurveYieldValue){
      //   this.getMuniCurveData(maturityDate,cusipSelected);
      // }
      // if(!this.bondDescriptionData.tenYearYieldValue){
      //   this.getTreasuryData(maturityDate,cusipSelected)
      // }
      
    },
    getMuniCurveData(cusip){

      if(cusip.bidType != 'YIELD' || cusip.amount == 0 || cusip.pointToDate == ""){
        return false
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      var yieldtype =  cusip.pointToDate == 'CALL' ? 'C' : 'M' ;
      var callDate = cusip.callDate ? cusip.callDate.replace(/-/g, "") : "";
      var maturityDate = cusip.maturityDate ?   cusip.maturityDate.replace(/-/g, "") : "";
      this.muniCurveYieldValue = 0
      cusip.muniCurveYieldValue = 0
      //this.bondDescriptionData.muniCurveYieldValue = 0;
      this.$http
        .get(
          config.baseUrlBidSide +
            "/yield/muni-curve?maturitydate="+
            maturityDate+
            "&calldate="+
            callDate+
            "&yieldtype="+
            yieldtype+
            "&yieldvalue="+
            cusip.amount,
          auth
        )
         .then(response => {
           cusip.muniCurveYieldValue = response.data.curveyield || 0;
           cusip.municurveBpsValue = "BPS "+response.data.bts || 0;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    getTreasuryData(cusip){
      if(cusip.bidType != 'YIELD' || cusip.amount == 0 || cusip.pointToDate == ""){
        return false
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      var yieldtype =  cusip.pointToDate == 'CALL' ? 'C' : 'M' ;
      var callDate = cusip.callDate ? cusip.callDate.replace(/-/g, "") : "";
      var maturityDate = cusip.maturityDate ?   cusip.maturityDate.replace(/-/g, "") : "";
      this.tenYearYieldValue = 0;
      cusip.tenYearYieldValue = 0;
      //this.bondDescriptionData.tenYearYieldValue = 0;
      this.$http
        .get(
          config.baseUrlBidSide +
          "/yield/ten-year-treasury?maturitydate="+
            maturityDate+
            "&calldate="+
            callDate+
            "&yieldtype="+
             yieldtype+
            "&yieldvalue="+
            cusip.amount,
          auth
        )
         .then(response => {
          cusip.tenYearYieldValue = response.data.curveyield || 0;
          cusip.tenYearBpsValue = "BPS "+response.data.bts || 0;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    getCurveDetails(cusip){
      // if(cusip.callDate == null || cusip.maturityDate == null){
      //   return false
      // }
      this.yieldLoader = true;
      var callDate = cusip.callDate ? cusip.callDate.replace(/-/g, "") : "";
      var maturityDate = cusip.maturityDate ?   cusip.maturityDate.replace(/-/g, "") : "";
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
          "/yield/yield-details?maturityDate="+
            maturityDate+
            "&callDate="+
            callDate,
          auth
        )
         .then(response => {
          this.muniCurveYieldOnCall = response.data.muniCurveCall || 0;
          this.muniCurveYieldOnMaturity = response.data.muniCurveMaturity || 0;
          this.tenYearYieldOnCall = response.data.treasuryCall || 0;
          this.tenYearYieldOnMaturity = response.data.treasuryMaturity || 0;
          this.maturityErrorMessage = response.data.maturityMessage || null;
          this.callErrorMessage = response.data.callMessage || null;
          this.yieldLoader = false;

        })
        .catch(e => {
          console.log(e);
          this.yieldLoader = false;

        });
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getOrgSettings(){
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
          "/organization/bid-settings?type=BID",
          auth
        )
        .then(response => {
          this.orgSettings = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  created() {
     this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.userSubId = authService.getUser().cognitoSub;
        this.getTraderSetting("onLoad");
        this.getOrgSettings();
      }
    });
  }
};
</script>
<style>
</style>
